export default function TrainsResultsController(
    trainsFactory,
    flightsService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        initFlights();
        vm.composeCompanyLogoUrl = flightsService.getFlightSupplierLogo;
    }

    function initFlights() {
        const flights = trainsFactory.getFlights();
        if (flights) {
            vm.total = flights.Total;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-results-controller.js